function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 5.25H33.25V1.75H29.75V5.25H12.25V1.75H8.75V5.25H7C5.075 5.25 3.5 6.825 3.5 8.75V36.75C3.5 38.675 5.075 40.25 7 40.25H35C36.925 40.25 38.5 38.675 38.5 36.75V8.75C38.5 6.825 36.925 5.25 35 5.25ZM35 36.75H7V17.5H35V36.75ZM35 14H7V8.75H35V14Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5 27C30.3579 27 27 30.3579 27 34.5C27 38.6421 30.3579 42 34.5 42C38.6421 42 42 38.6421 42 34.5C41.9956 30.3597 38.6403 27.0044 34.5 27ZM35.0357 34.5C35.0357 34.7959 34.7959 35.0357 34.5 35.0357H30.2143C29.9184 35.0357 29.6786 34.7959 29.6786 34.5C29.6786 34.2041 29.9184 33.9643 30.2143 33.9643H33.9643V30.2143C33.9643 29.9184 34.2042 29.6786 34.5 29.6786C34.7959 29.6786 35.0357 29.9184 35.0357 30.2143V34.5Z",
  fill: "white"
});

function SvgCalendarLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLock);
export default __webpack_public_path__ + "static/media/calendar-lock.6ad1febf.svg";
export { ForwardRef as ReactComponent };